import type { ReactNode } from 'react'
import styles from './RowActions.module.css'

/** Right-aligned action group for a table row. */
export function RowActions({ children }: { children: ReactNode }) {
  return <div className={styles.actions}>{children}</div>
}

interface KeyValueProps {
  label: string
  children: ReactNode
  /** Lets a long address or note span the full width of a detail grid. */
  wide?: boolean
}

export function KeyValue({ label, children, wide = false }: KeyValueProps) {
  return (
    <div className={wide ? styles.itemWide : styles.item}>
      <dt className={styles.label}>{label}</dt>
      <dd className={styles.value}>{children}</dd>
    </div>
  )
}

export function KeyValueGrid({ children }: { children: ReactNode }) {
  return <dl className={styles.grid}>{children}</dl>
}

/** Two-line table cell: a primary value with quieter context beneath. */
export function StackedCell({ primary, secondary }: { primary: ReactNode; secondary?: ReactNode }) {
  return (
    <div className={styles.stacked}>
      <span className={styles.stackedPrimary}>{primary}</span>
      {secondary ? <span className={styles.stackedSecondary}>{secondary}</span> : null}
    </div>
  )
}
